// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var Button      = require("./components/Button");
var Select      = require("./components/Select");
var TextField   = require("./components/TextField");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./App.css')));

var animals = /* :: */[
  /* record */[
    /* value */"dog",
    /* label */"Dog"
  ],
  /* :: */[
    /* record */[
      /* value */"frog",
      /* label */"Frog"
    ],
    /* :: */[
      /* record */[
        /* value */"sloth",
        /* label */"Sloth"
      ],
      /* [] */0
    ]
  ]
];

var component = ReasonReact.reducerComponent("App");

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var state = param[/* state */2];
      var reduce = param[/* reduce */1];
      return React.createElement("div", {
                  className: "App-root"
                }, React.createElement("header", {
                      className: "App-header"
                    }, React.createElement("h1", undefined, "Reason React", React.createElement("br", undefined), "Material UI"), React.createElement("div", {
                          className: "App-header-separator"
                        }), React.createElement("h3", undefined, "A simple form built with Reason React and Material UI")), React.createElement("main", undefined, React.createElement("form", {
                          className: "App-form",
                          autoComplete: "off"
                        }, ReasonReact.element(/* None */0, /* None */0, TextField.make("Name", state[/* name */0], Curry._1(reduce, (function (e) {
                                        return /* ChangeName */Block.__(0, [e]);
                                      })), /* array */[])), ReasonReact.element(/* None */0, /* None */0, Select.make("Favorite Animal", animals, state[/* favoriteAnimal */1], Curry._1(reduce, (function (e) {
                                        return /* ChangeFavoriteAnimal */Block.__(1, [e]);
                                      })), /* array */[])), React.createElement("div", {
                              className: "App-button-container"
                            }, ReasonReact.element(/* None */0, /* None */0, Button.make((function () {
                                        console.log("SENT");
                                        return /* () */0;
                                      }), /* array */["Send"]))))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* name */"",
              /* favoriteAnimal */"dog"
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (action.tag) {
        return /* Update */Block.__(0, [/* record */[
                    /* name */state[/* name */0],
                    /* favoriteAnimal */action[0]
                  ]]);
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* name */action[0],
                    /* favoriteAnimal */state[/* favoriteAnimal */1]
                  ]]);
      }
    });
  return newrecord;
}

exports.animals   = animals;
exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/App.re
// module id = 185
// module chunks = 0